"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const _555Icon = createIcon({
  displayName: "_555Icon",
  viewBox: "0 0 500 500",
  path: (
    <>
      <path
        d="m30.291468 26.824522h60.861931v60.861931h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m124.81499 26.82568h60.861931v60.863091h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m30.291468 123.12381h60.861931v60.860775h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m124.81499 123.12495h60.861931v60.861931h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m219.64548 27.115267h60.860775v60.861931h-60.860775z"
        fill="currentColor"
      />
      <path
        d="m314.16785 27.116425h60.863091v60.861931h-60.863091z"
        fill="currentColor"
      />
      <path
        d="m219.64548 123.41454h60.860775v60.860775h-60.860775z"
        fill="currentColor"
      />
      <path
        d="m314.16785 123.41571h60.863091v60.861931h-60.863091z"
        fill="currentColor"
      />
      <path
        d="m30.291468 219.71266h60.861931v60.864246h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m124.81499 219.71266h60.861931v60.864246h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m30.291468 316.0108h60.861931v60.863091h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m124.81499 316.01312h60.861931v60.860775h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m219.64548 219.71266h60.860775v60.861931h-60.860775z"
        fill="currentColor"
      />
      <path
        d="m314.16785 219.71266h60.863091v60.864246h-60.863091z"
        fill="currentColor"
      />
      <path
        d="m219.64548 316.0108h60.860775v60.863091h-60.860775z"
        fill="currentColor"
      />
      <path
        d="m314.16785 316.01312h60.863091v60.860775h-60.863091z"
        fill="currentColor"
      />
      <path
        d="m408.69138 27.116425h60.863091v60.861931h-60.863091z"
        fill="currentColor"
      />
      <path
        d="m408.69138 123.41571h60.863091v60.861931h-60.863091z"
        fill="currentColor"
      />
      <path
        d="m408.69138 219.71266h60.863091v60.864246h-60.863091z"
        fill="currentColor"
      />
      <path
        d="m408.69138 316.01312h60.863091v60.860775h-60.863091z"
        fill="currentColor"
      />
      <path
        d="m30.444365 412.31238h60.861931v60.863091h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m124.9679 412.3147h60.861931v60.860775h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m219.79839 412.31238h60.861931v60.863091h-60.861931z"
        fill="currentColor"
      />
      <path
        d="m314.31961 412.3147h60.865406v60.860775h-60.865406z"
        fill="currentColor"
      />
      <path
        d="m408.84314 412.3147h60.865406v60.860775h-60.865406z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default _555Icon;
